"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpandableTypography = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var miscHooks_1 = require("../../../hooks/miscHooks");
function useExpandableTypography(_a) {
    var children = _a.children, numberOfLines = _a.numberOfLines, showMore = _a.showMore;
    var ref = (0, react_1.useRef)(null);
    var _b = __read((0, react_1.useState)(false), 2), isExpanded = _b[0], setIsExpanded = _b[1];
    var calculateShouldRenderButton = (0, react_1.useCallback)(function () {
        if (!ref.current) {
            return false;
        }
        return ref.current.offsetHeight < ref.current.scrollHeight;
    }, [ref]);
    var _c = __read((0, react_1.useState)(false), 2), shouldRenderButton = _c[0], setShouldRenderButton = _c[1];
    (0, react_1.useEffect)(function () {
        if (showMore) {
            setShouldRenderButton(calculateShouldRenderButton());
        }
    }, [calculateShouldRenderButton, numberOfLines, children, showMore]);
    (0, miscHooks_1.useWindowEventListener)('resize', showMore ? function () { return setShouldRenderButton(calculateShouldRenderButton); } : lodash_1.noop, 200);
    return {
        calculatedNumberOfLines: isExpanded ? undefined : numberOfLines,
        isExpanded: isExpanded,
        ref: ref,
        shouldRenderButton: shouldRenderButton,
        toggleIsExpanded: function () { return setIsExpanded(function (state) { return !state; }); },
    };
}
exports.useExpandableTypography = useExpandableTypography;
